module.exports = __webpack_public_path__ + "static/media/salesforce.373de2c0.jpeg";